import Helmet from "react-helmet";
import React from "react";
import ExtendedHomepage from "src/components/extendedHomepage";
import HomepageLayout from "src/layouts/homepage";
import Disclaimers from "@tightrope/disclaimers"
import RawFooter from "@tightrope/footerlinks/rawfooter.js"

const homepageData = import("./homepage.json");

export default function HomePage() {
  return (
    <HomepageLayout>
      <Helmet>
        <style type="text/css">{`
     #disclaimers-module--disclaimers {
     margin:32px auto 0;
      width:400px;
      }

     #disclaimers-module--disclaimers p {
      font-weight: 300;
      color: #222;
      font-size: 13px;
      text-align: center;
      font-family: Roboto,sans-serif;
      width:100%;
      margin: 0 auto;
      }

      #disclaimers-module--disclaimers p a {
      color:#222;
      }
              
            .footerlinkssingle-module--br {
            text-align:center;
        }
        `}</style>

        <title>Easy View</title>
      </Helmet>

      <ExtendedHomepage data={homepageData}>
      <Disclaimers language='en-easyview'>
      </Disclaimers>
      </ExtendedHomepage>
      <RawFooter language='en-easyview'></RawFooter>
    </HomepageLayout>
  );
}
